/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const node = feature as BaseNode;

    const incomingLinks = project.getNodeLinks(node, 'cond');
    const trueLinks = project.getNodeLinks(node, 'true_output');
    const falseLinks = project.getNodeLinks(node, 'false_output');
    for (let i = 0; i < incomingLinks.length; i += 1) {
        const link = incomingLinks[i];

        const CODE = feature.getSettingValue('CODE');

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
    if ${CODE}:
        ${trueLinks.length > 0 ? `#****${trueLinks[0].getSourceId()}****#` : ''}
        pass
    else
        ${falseLinks.length > 0 ? `#****${falseLinks[0].getSourceId()}****#` : ''}
        pass`,
        });
    }

    return blocks;
};
